import { useState } from 'react';
import { TextButton } from '@packages/shared/core/common/components/common/Button';
import ButtonBack from '@packages/shared/core/common/components/common/ButtonBack';
import CircularProgress from '@packages/shared/core/common/components/common/CircularProgress';
import {
  ExpertCard,
  ExpertCardHorizontal,
} from '@packages/shared/core/common/components/common/ExpertCatalogue';
import Header from '@packages/shared/core/common/components/layout/Header';
import { LoadingStatuses } from '@packages/shared/core/common/entities';
import { ExpertsCatalogueScreenProps } from '@packages/shared/core/quiz/entities';
import Banner from '@packages/shared/simple-simple-registration/components/Banner';
import ExpertsCatalogueScreenModal from './ExpertsCatalogueScreenModal';
import styles from './ExpertsCatalogueScreen.module.scss';
const ExpertsCatalogueScreen = ({
  content,
  goBack,
  experts,
  fetchMoreExperts,
  loadingStatus,
  isInitialExpertsLoaded,
  chooseExpert,
}: ExpertsCatalogueScreenProps) => {
  const [isModalShow, setIsModalShow] = useState(true);
  const [isButtonShow, setIsButtonShow] = useState(true);

  const showMoreExperts = () => {
    fetchMoreExperts();
    setIsButtonShow(false);
  };

  const isAllExpertsLoaded = loadingStatus !== LoadingStatuses.IDLE;
  const isAllExpertsLoading = loadingStatus === LoadingStatuses.PENDING;

  return (
    <>
      <div className={styles.background} />

      <Header className={styles.header} menuClassName={styles.menu}>
        <ButtonBack className={styles.buttonBack} secondary onClick={goBack} />
      </Header>

      <div className={styles.container}>
        {content.title && <h2 className={styles.title}>{content.title}</h2>}

        {content.subtitle && <h3 className={styles.subtitle}>{content.subtitle}</h3>}

        <ul className={styles.list}>
          {isInitialExpertsLoaded ? (
            experts.map((expert) => (
              <li className={styles.listItem} key={expert.id}>
                <ExpertCard
                  className={styles.mobileCard}
                  onStartChat={() => chooseExpert(expert.id)}
                  expert={expert}
                />

                <ExpertCardHorizontal
                  className={styles.desktopCard}
                  onStartChat={() => chooseExpert(expert.id)}
                  expert={expert}
                />
              </li>
            ))
          ) : (
            <CircularProgress />
          )}
        </ul>

        {isAllExpertsLoading && <CircularProgress />}

        {isButtonShow && !isAllExpertsLoaded && (
          <TextButton
            wrapperClassName={styles.buttonWrapper}
            className={styles.button}
            onClick={showMoreExperts}
          >
            Explore all advisors
          </TextButton>
        )}
      </div>

      <ExpertsCatalogueScreenModal
        open={isModalShow}
        onClose={() => setIsModalShow(false)}
        icon={content.modalIcon}
        title={content.modalTitle}
        description={content.modalDescription}
        button={content.modalButton}
      />
    </>
  );
};

export default ExpertsCatalogueScreen;
